import { useMutation } from 'react-query';
import { userService } from 'services/user';
import { TFlagTypes } from 'types/flags';

type TUserFlagRequest = {
  getUserFlags: (queryParams: string[]) => Promise<TFlagTypes | undefined>;
  updateUserFlag: (
    key: string,
    value: string | number | boolean
  ) => Promise<boolean>;
};

function useUserFlagRequest(): TUserFlagRequest {
  const { mutateAsync: fetchUserFlags, error: hasError } = useMutation(
    'getUserFlags',
    userService.getUserFlags
  );

  const { mutateAsync: setUserFlag } = useMutation(
    'setUserFlag',
    userService.setUserFlag
  );

  async function getUserFlags(
    queryParams: string[]
  ): Promise<TFlagTypes | undefined> {
    try {
      const userFlags = await fetchUserFlags(queryParams);
      if (!userFlags?.data?.result) {
        throw new Error('Couldnt get user data');
      }
      return userFlags.data.result.flags;
    } catch (error) {
      return undefined;
    }
  }

  async function updateUserFlag(
    key: string,
    value: string | number | boolean
  ): Promise<boolean> {
    if (!hasError) {
      try {
        const response = await setUserFlag({ params: { key, value } });
        if (!response?.data?.success) {
          throw new Error('Couldnt set user data');
        }
        return true;
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  return { getUserFlags, updateUserFlag };
}

export default useUserFlagRequest;
